/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="16.44"
        viewBox="0 0 19 16.44"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M19 3.06v-.09L14 .11l-.39.22c-.54.22-1.69.87-4.17 2.3L4.98 0 .09 2.85H.02v13.54l.16-.16 2.8-1.78 1.94-1.2 4.42 2.55h.08l.42-.25c.53-.24 1.66-.9 4.13-2.35l5 2.88ZM4.35 12.44 1 14.55V3.5l3.44-2c0 2.26-.06 8.52-.09 10.94Zm4.55 2-3.55-2c.07-6.82.1-9.68.09-11l3.51 2.07c-.05 6.47-.07 9.6-.05 10.99Zm4.51-2-3.51 2v-11l3.53-2c0 1.86 0 6.84-.07 10.9Zm4.56 2-3.56-2.05c.07-6.68.09-9.58.07-10.86l3.52 2Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'MapIcon';

export default Icon;
